import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const Protected = ({ roles, children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">Loading…</div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "driver" ? "/driver" : user.role === "admin" ? "/billing" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
};
